import React, { useState, useEffect, useContext } from "react";
import { FaUserAlt, FaLock } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext"; // importa tu context

export default function Login() {
  const { login } = useContext(AuthContext); // usamos login del contexto
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Todos los campos son obligatorios");
      return;
    }

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Correo o contraseña incorrectos");
        return;
      }

      // El backend ya dejó la cookie de sesión (httpOnly); cargamos perfil/modulos
      await login();

      // Mostrar alerta y redirigir
      setSuccess("Login exitoso!");
      setTimeout(() => {
        navigate("/dashboard"); // redirige a perfil
      }, 1000);

    } catch (err) {
      console.error(err);
      setError("Error de conexión con el servidor");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setError("");
      setSuccess("");
    }, 3000);
    return () => clearTimeout(timer);
  }, [error, success]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4 relative">
      {/* Alertas flotantes */}
      <div className="fixed top-5 right-5 z-50 space-y-2">
        {error && <div className="bg-red-500 text-white px-6 py-3 rounded shadow-lg">{error}</div>}
        {success && <div className="bg-green-500 text-white px-6 py-3 rounded shadow-lg">{success}</div>}
      </div>

      {/* Caja de login */}
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src="/logoIBFMO.png" alt="Logo Iglesia" className="h-32 w-32 object-contain" />
        </div>
        <h2 className="text-center text-2xl font-bold text-gray-800">¡Bienvenido!</h2>
        <p className="text-center text-gray-500 mb-6">Inicia sesión para continuar</p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="relative">
            <FaUserAlt className="absolute left-3 top-3 text-gray-400" />
            <input
              type="email"
              placeholder="usuario@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-10 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="relative">
            <FaLock className="absolute left-3 top-3 text-gray-400" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-10 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <div
              className="absolute right-3 top-3 text-gray-400 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <AiFillEyeInvisible className="w-5 h-5" /> : <AiFillEye className="w-5 h-5" />}
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-md font-semibold"
          >
            Iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
}